<template lang="pug">

    v-menu(
        :close-on-content-click='false'
        transition='scale-transition'
        offset-y
        max-width='290px'
        min-width='290px'
    )
        template(v-slot:activator="{ on, attrs }")
            v-row
                v-col
                    v-btn(@click="translateMessage('english');" color="grey" text-color="white" small :disabled="isTranslationLoading")
                        | English
                v-col
                    v-btn(@click="translateMessage('french');" color="grey" small :disabled="isTranslationLoading")
                        | French
                v-col
                    v-btn(@click="translateMessage('german');" color="grey" small :disabled="isTranslationLoading")
                        | German
                v-col
                    v-btn(@click="translateMessage('spanish');" color="grey" small :disabled="isTranslationLoading")
                        | Spanish
</template>

<script lang="ts">
import Vue from 'vue';

// Components

export default Vue.extend({
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    },
    components: {

    },
    props: {
        campaign: Object,
        isTranslationLoading: Boolean,
        translateMessage: Function,
    },
    watch: {

    },
    created() {
    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>

</style>